var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"button"},[_c('div',{staticClass:"artificial",on:{"click":_vm.goToArtificial}},[_vm._v("专人报价")]),_c('div',{staticClass:"automatic",on:{"click":_vm.goToAutoPrice}},[_vm._v("人保报价")])])])}
var staticRenderFns = []

export { render, staticRenderFns }